module.exports = __webpack_public_path__ + "static/media/page06_bg - Copy.7e8e7fc4.png";